// Greek names for the sticker-shelf rewards and the football cups.
//
// Laid over the data at DISPLAY time only. `REWARDS[].name` is a KEY:
// `FRIEND_DRAWINGS[r.name]` looks up the drawable friend by its English name, so
// translating the data itself would silently break every "tap a friend to draw
// it" button. Only what the child reads is translated.
//
// Greek declines, and these names appear only inside sentences that take the
// ACCUSATIVE — "Κέρδισες **τον σκύλο**", "Ζωγράφισε **τη γάτα**" — so `name` is
// the accusative form and `article` is the definite accusative article
// ("τον "/"τη "/"το ", with its trailing space).

import type { RewardFr } from "./rewards.fr";

/** English reward name (the key into FRIEND_DRAWINGS) → Greek. */
export const REWARDS_EL: Record<string, RewardFr> = {
  Mouse: { name: "Ποντίκι", article: "το " },
  Frog: { name: "Βάτραχο", article: "τον " },
  Hamster: { name: "Χάμστερ", article: "το " },
  Duck: { name: "Πάπια", article: "τη " },
  Bunny: { name: "Κουνελάκι", article: "το " },
  Cat: { name: "Γάτα", article: "τη " },
  Fox: { name: "Αλεπού", article: "τη " },
  Dog: { name: "Σκύλο", article: "τον " },
  Penguin: { name: "Πιγκουίνο", article: "τον " },
  Pig: { name: "Γουρούνι", article: "το " },
  Pony: { name: "Πόνι", article: "το " },
  Cow: { name: "Αγελάδα", article: "τη " },
  Lion: { name: "Λιοντάρι", article: "το " },
  Horse: { name: "Άλογο", article: "το " },
  Bear: { name: "Αρκούδα", article: "τη " },
  Elephant: { name: "Ελέφαντα", article: "τον " },
  Whale: { name: "Φάλαινα", article: "τη " },
  Dinosaur: { name: "Δεινόσαυρο", article: "τον " },
};

/** English cup name → Greek. */
export const CUPS_EL: Record<string, RewardFr> = {
  "Kickoff Cup": { name: "Κύπελλο Έναρξης", article: "το " },
  "Bronze Cup": { name: "Χάλκινο Κύπελλο", article: "το " },
  "Silver Cup": { name: "Ασημένιο Κύπελλο", article: "το " },
  "Gold Cup": { name: "Χρυσό Κύπελλο", article: "το " },
  "Champions Cup": { name: "Κύπελλο Πρωταθλητών", article: "το " },
};
